import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--main bonusomat-raffle-counters__counter-box--highlighted allwyn-heading-box" }
const _hoisted_2 = { class: "allwyn-heading-box__headline" }
const _hoisted_3 = ["innerHTML"]

import { computed } from "vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'allwyn-heading-box',
  props: {
    name: {}
  },
  setup(__props: any) {

const props = __props;

const additionalClass = computed(() => (props.name.length > 25 ? "allwyn-heading-box__name--long" : ""));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(WebpImage, {
        src: "/frontend/web/img/casino/bonusomat/raffle/raffle-joker.svg",
        alt: "allwyn žolík",
        class: "allwyn-heading-box__logo"
      }),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "allwyn-heading-box__title" }, "Zážitek", -1))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["allwyn-heading-box__name", additionalClass.value]),
      innerHTML: _ctx.name
    }, null, 10, _hoisted_3)
  ]))
}
}

})